import React, { useContext, useCallback, forwardRef, useRef, useImperativeHandle } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { getYear, getMonth } from 'date-fns';
import range from 'lodash/range';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';

import { MONTH_NAMES } from 'utils/date';

import { LocaleContext } from 'context/LocaleContext';

import Select from 'components/select';

import IconArrowLeft from 'icons/icon-arrow-left';
import IconArrowRight from 'icons/icon-arrow-right';

const LocalizedDatePicker = forwardRef((props: any, ref) => {
    const { t } = useTranslation('date');
    const datePickerRef = useRef(null);

    const localeContext = useContext(LocaleContext);

    const currentYear = new Date().getFullYear();
    const years = range(currentYear - 10, currentYear + 10, 1);
    const months = MONTH_NAMES;

    const renderDatePickerHeader = useCallback(({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled, }) => (
        <div className="datepicker-header">
            <button className="btn btn-secondary btn-xsmall btn-icon btn-square" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                <IconArrowLeft size="13px" />
            </button>

            <div className="datepicker-header-selects">
                <Select
                    xsmall={true}
                    withoutPortal={true}
                    selected={getYear(date)}
                    options={years.map(year => ({ id: year, text: year }))}
                    onChange={({ id }) => changeYear(id)}
                />

                <Select
                    xsmall={true}
                    withoutPortal={true}
                    selected={getMonth(date)}
                    options={months.map((month, index) => ({ id: index, text: t(`months.${month}`) }))}
                    onChange={({ id }) => changeMonth(id)}
                />
            </div>

            <button className="btn btn-secondary btn-xsmall btn-icon btn-square" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                <IconArrowRight size="13px" />
            </button>
        </div>
    ), []);

    useImperativeHandle(ref, () => {
        return datePickerRef.current?.input;
    }, [datePickerRef]);

    return (
        <DatePicker
            ref={datePickerRef}
            locale={localeContext?.getLocale()}
            timeFormat={localeContext.dateTimeFormats.time}
            renderCustomHeader={renderDatePickerHeader}
            {...props}
        />
    );
});

export default LocalizedDatePicker;
